export default __webpack_public_path__ + "static/media/avatar5.446ca40b.png";